/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CompanySizeDto = {
    Micro: 'MICRO',
    Small: 'SMALL',
    Medium: 'MEDIUM',
    Big: 'BIG',
    Enterprise: 'ENTERPRISE',
} as const;

export type CompanySizeDto = typeof CompanySizeDto[keyof typeof CompanySizeDto];



